import { Component } from '@angular/core';


export class MyComponent {
  constructor() {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'my-component',
  template: `<div>I'm a special snowflake</div>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
